import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'gira',
} as IModuleProps;
